/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { autobind } from 'packages/core/lib';

import {
  Grid,
  Row,
  Column,
  Keyboard,
  Button,
  Heading,
  Form,
  FormInput,
  cls,
  ColoredButton, TranslationID
} from 'packages/components';
import './_styles.scss';
import Assets from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';
import { LOGIN, REGISTER_INPUT_STYLE_OUTFOCUS } from '../utils/constants';
import {
  LABEL_INICIA_SESION,
  LABEL_FORGOT_PASSWORD,
  LABEL_MAIL_NEXT,
  LABEL_MAIL_CANCEL,
  LABEL_MAIL_INSERT_PASSWORD_CANCEL,
  LABEL_MAIL_INSERT_PASSWORD_NEXT,
  LOGINL
} from '../utils/constantsMetrics';
import Device from '../../devices/device';
import LoginLogic from './LoginLogic';
import {
    LOGIN_EMAIL, LOGIN_NET, LOGIN_HDTV
} from '../../AAF/Auth/authConstants';
import { receiveIsLoggedIn, fetchPushSession } from '../../reducers/user';
import { setMetricsEvent } from '../../actions/metrics';
import { fetchLinealChannels } from '../../actions/payway';
import { MODAL_ACCEPT_TERM, MODAL_TERM_AND_COND, MODAL_REGISTER_NET, showModal } from '../../actions/modal';
import { regExp } from 'packages/components/lib/Input/utils';
import { getUserInfo, login, loginNET} from '../../requests/loader';
import Spinner from './../../components/Spinner';
import { createAsyncEvent } from '../../utils/analytics';
import HistoryRegion from '../../utils/HistoryRegion';
import { HeaderLoginLabels } from './HeaderBrasil';
import DeviceStorage  from '../../components/DeviceStorage/DeviceStorage';
import Utils from "../../utils/Utils";
import {GA4} from 'src/utils/trackers/GA4';
import {METHOD_EMAIL} from 'src/utils/trackers/GA4Constants';
import { setParamsYouboraLogin } from 'src/config/youboraLoader';
import { getUrlRedirectBack } from 'src/components/Modal/functions/ModalKeepWatching/functions';
import {
    trackAuthLoginPageViewed,
    trackAuthLoginSubmitted,
    trackAuthRegisterHandoffSubmitted,
} from '../../services/datadog/auth';

enum Steps {
    STEP_MAIL = 'INSERT_MAIL',
    STEP_PASSWORD = 'INSERT_PASSWORD'
}

interface IProps {
    errorMsg: string;
}

interface IStepsValue {
    [key: string]: string | undefined;
    title: string;
    subtitle: string;
    placeholder: string;
    next?: string;
    cancel?: string;
    register?: string;
}

interface ILoginState {
    step: string;
    email: string;
    password: string;
    showPassword: boolean;
    errorFromBackend: string;
    valid: boolean;
    isLoading: boolean;
    typeRegisterNet: string;
    device: string;
    focusWhenMount: boolean;
}

class Login extends Component<RouteComponentProps & IProps, ILoginState> {
    private translations: Record<TranslationID, string> = {
      'password_tooltip_completeField': Translator.get('password_tooltip_completeField_label_validation','Debes completar este campo'),
      'email_tooltip_valid': Translator.get('email_tooltip_valid_label_validation','Ingresa un correo electrónico válido.'),
      'loginMail_tooltip_error_label': Translator.get('loginMail_tooltip_error_label', 'Este correo no está vinculado a la base de datos de Claro Video')
    };
    public textBack: string = Translator.get('top_head_option_button_back', 'Regresar');
    public headerLogo: string = Assets.get('logo_clarotv') || '';
    private loginLogic: LoginLogic;
    private isValidForm: boolean;
    private region: string;
    public keys = Device.getDevice() && Device.getDevice().getKeys() || null;
    public passwordShowButtonOff: string = Assets.get('password_access_show_button_off') || '';
    public passwordShowButtonOn: string = Assets.get('password_access_show_button_on') || '';
    public  analyticsEvent = createAsyncEvent(
        {
       send: event => {
         this.props.setMetricsEvent(event);
         this.props.setMetricsEvent({ type: 'executor' });
       }
     });
     private typeRegisterNetUpdate: string;

    constructor(props: RouteComponentProps & IProps) {
        super(props);
        this.state = {
            step: Steps.STEP_MAIL,
            email: '',
            password: '',
            showPassword: false,
            errorFromBackend: '',
            valid: true,
            isLoading: false,
            typeRegisterNet: this.props.location.typeRegisterNet,
            device: Device.getDevice().getPlatform(),
            focusWhenMount: true
        };

        this.loginLogic = new LoginLogic(props);
        this.isValidForm = false;
        this.analyticsEvent;
        this.region = DeviceStorage.getItem('region');
    }

    public componentDidUpdate(): void {

        const { step, password} = this.state;

        if (step === Steps.STEP_PASSWORD && password.length !== 0 && !this.isValidForm){
            this.handlePasswordChange(password);
        }
    }

    public componentDidMount(): void {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener("keydown", this.handleKeyPress, true);
        document && document.addEventListener('keydown', this.onFocus, true);
        Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');

        let stepD = (this.props
            && this.props.location
            && this.props.location.state
            && this.props.location.state.InsertPassword)? Steps.STEP_PASSWORD : Steps.STEP_MAIL;

        let emailPassword = (this.props
            && this.props.location
            && this.props.location.state
            && this.props.location.state.email);
        if(emailPassword || stepD) {
            this.setState({email:emailPassword, step: stepD, });
        }
    }
    public componentWillUnmount(): void {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.removeEventListener('keydown', this.handleKeyPress, true);
        document && document.removeEventListener('keydown', this.onFocus, true);
    }

    private getTextBySteps = (attribute: string): string => {
        const { step } = this.state;
        let result: IStepsValue = {
            title: Translator.get('login_access_title_label','Inicia sesión'),
            subtitle: Translator.get('login_access_description_label','¿Cuál es tu número Telcel o tu correo electrónico?'),
            placeholder: Translator.get('login_access_placeHolder_textfield', 'Número a 10 dígitos o correo'),
            next: Translator.get('login_access_option_button_next','Siguiente'),
            cancel: Translator.get('login_access_option_button_cancel','Cancelar'),
            register: Translator.get('login_access_option_button_register','¿Nuevo en Claro video? Registrate')
        };

        switch (step) {
            case Steps.STEP_MAIL:
                break;
            case Steps.STEP_PASSWORD:
                result = {
                    title: Translator.get('login_password_title_label','Inicia sesión'),
                    subtitle: Translator.get('login_password_description_label','Contraseña'),
                    placeholder: Translator.get('login_password_placeHolder_textfield','Ingresa tu contraseña'),
                    forgetPasswordBtn: Translator.get('login_password_option_button_passwordRecovery','¿Olvidaste tu contraseña? Recupérala aquí'),
                    next: Translator.get('login_password_option_button_next','SIGUIENTE'),
                    cancel: Translator.get('login_password_option_button_cancel','CANCELAR'),
                };
                break;
            default:
                break;
        }

        return result[attribute] ?? '';
    };

    private handleForgetPassword = (): void => {
        const { history } = this.props;
        Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, LABEL_FORGOT_PASSWORD, LABEL_INICIA_SESION);
        history.push('/password-reminder', { email: this.state.email });
    };

    private gotoRegister = (): void => {
        const { history } = this.props;
        trackAuthRegisterHandoffSubmitted({
            origin: 'login',
        });
        history.push('/register', {from: 'login'});
    };

     componentWillUpdate(NewProps: any){
        this.typeRegisterNetUpdate = NewProps.location.typeRegisterNet;
     }

    private handleStepPassword = (): void => {
        const { email } = this.state;
        if(!regExp.validEmail.test(email) || !regExp.hasNumberMobile.test(email)) {
            this.setState({ valid: false });
        }
        if (regExp.validEmail.test(email) || regExp.hasNumberMobile.test(email)) {
            getUserInfo(email).then((result) => {
                setParamsYouboraLogin(result.response.id_usuario, result.response.email);

                this.isValidForm = false;
                Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
                this.setState({ step: Steps.STEP_PASSWORD, valid: true, errorFromBackend: '' });
            })
            .catch(e => {
                this.setState({ valid: false, errorFromBackend: this.translations['loginMail_tooltip_error_label'] });
            });
        } else {
            if (this.region === 'brasil') {
                this.setState({ step: Steps.STEP_PASSWORD, valid: true, errorFromBackend: '' });
            }
        }
    };

    async handleSubmit() {
        const  { email, password } = this.state;
        const loginParams = {email,password,username:email,includpaywayprofile: true};
        const { step, typeRegisterNet } = this.state;
        const currentRegisterType = typeRegisterNet && (typeRegisterNet !== LOGIN_EMAIL) ? typeRegisterNet : step ;

        let loginFunction = login;
        switch (currentRegisterType) {
        case LOGIN_EMAIL:
            loginFunction = login;
            break;
        case LOGIN_NET:
        case LOGIN_HDTV:
            loginFunction = loginNET;
            delete loginParams['captcha'];
            break;
        }
        trackAuthLoginSubmitted({
            screen: 'login',
            step,
        });
        this.setState({isLoading: true});
        this.loginLogic.loginFLow(loginParams, loginFunction).then(error => {
          if(error && (error.message || error.code)) {
            this.setState({isLoading: false});
            const errorMessage = error.code ? Translator.get(error.code, 'La contraseña no es válida, verifícala.') : error.message ;
            this.isValidForm = false;
            this.setState({ valid: false, errorFromBackend: errorMessage, password: ''});
          } else {
            trackAuthLoginPageViewed({
                screen: 'login',
            });
            this.sendGA4Metric(this.props.history, null, null, LOGINL);
            Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, `exitoso - ${currentRegisterType === LOGIN_EMAIL ? 'correo' : 'autologin'}`, LABEL_INICIA_SESION);
          }
        });
    }

    @autobind
    private showAcceptTerm() {
        this.loginLogic.setDataLegal();
        LoginLogic.getConfigRemoteControl();
        const modal = {
            modalType: MODAL_ACCEPT_TERM,
            modalProps: {
                onAccept: () => this.acceptTermAndCond(),
                onShowTermAndCond: () => this.onShowTermAndCond()
            }
        };
        this.props.showModal(modal);
    }

    @autobind
    async onShowTermAndCond() {
        const modal = {
            modalType: MODAL_TERM_AND_COND,
            modalProps: {
                onShowAcceptTerm: () => this.showAcceptTerm()
            }
        };
        this.props.showModal(modal);
    }

    @autobind
    public onSuccessLogin(redirectTo: string, withHistory: boolean, isPush: boolean) {
        if (withHistory) {
            if (isPush) {
                this.props.history.push(redirectTo);
            }
            else {
                this.props.history.replace(redirectTo);
            }
        }
        else {
            window.location.href = redirectTo;
        }
    }

    private handleCancel = (): void => {
        const { step } = this.state;
        switch (step) {
            case Steps.STEP_MAIL:
                Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, LABEL_MAIL_CANCEL, LABEL_INICIA_SESION);
                this.handleLanding();
                break;
          case Steps.STEP_PASSWORD:
            Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, LABEL_MAIL_INSERT_PASSWORD_CANCEL, LABEL_INICIA_SESION);
            setParamsYouboraLogin(null, null)

            this.handleLanding();
            break;
            default:
                break;
        }
    };

    private handleLanding = (): void => {
        const { history } = this.props;
        const urlRedirect = getUrlRedirectBack('/landing');
        history.push(urlRedirect);
    };

    private changePasswordToShow = (): void => {
        const { showPassword } = this.state;
        // Show error
        this.setState({ showPassword: !showPassword });
    };

    private sendGA4Metric(history:any, interaction_type:any, moduleName:any, event:any) {
        const gA4 = new GA4();
        gA4.sendLoginEvent(METHOD_EMAIL);

        const dataMetrics = Utils.getDataRecoverPassword(history, interaction_type, moduleName, event);
        gA4.sendMetricsRecoverPassword(dataMetrics);
    }

    private handleNextStep = (): void => {
      const { step, email, password } = this.state;
      let inputToValue: string;

      if(step === 'INSERT_PASSWORD'){
        inputToValue = password !== '' ? password : '';
      } else {
        inputToValue = email !== '' ? email : '';
      }
      if (inputToValue === undefined || inputToValue === '') {
        this.setState({ valid: false, errorFromBackend: this.translations['password_tooltip_completeField']});
        return;
      }

        switch (step) {
            case Steps.STEP_MAIL:
              Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, LABEL_MAIL_NEXT, LABEL_INICIA_SESION);
              if (this.region === 'brasil') {
                this.handleStepPassword();
              } else {
                if(regExp.validEmail.test(inputToValue)) {
                    this.handleStepPassword();
                  } else {
                    this.setState({ valid: false, errorFromBackend: this.translations['email_tooltip_valid']});
                  }
              }
            break;
            case Steps.STEP_PASSWORD:
                Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, LABEL_MAIL_INSERT_PASSWORD_NEXT, LABEL_INICIA_SESION);
                this.handleSubmit();
                break;
            default:
                break;
        }
    };

    @autobind
    private handleBack():void {
        const { step, email } = this.state;
        const back = false;
        const islogin = true;

        if(step === Steps.STEP_PASSWORD){
            this.isValidForm = true;
            Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
            this.setState({ email, step: Steps.STEP_MAIL, errorFromBackend: '' });
        } else {
            HistoryRegion.getUrlLogin(MODAL_REGISTER_NET, this.props, back, islogin  )
        }
    }

    @autobind
    private handleEmailChange(value: string): void {
        let { valid } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || regExp.validEmail.test(value) || regExp.hasNumberMobile.test(value) || regExp.hasNumbers.test(value)) {
            valid = true;
        } else {
          valid = false;
        }
        this.setState({ email: value, valid, errorFromBackend: '' });
    }

    @autobind
    private handlePasswordChange(value: string): void {
        let { valid } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || regExp.validEmail.test(value) || regExp.hasNumberMobile.test(value)) {
            valid = true;
        }
        this.setState({ password: value, valid, errorFromBackend: '' });
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch(currentKey){
            case "YELLOW":
                e.preventDefault();
                e.stopPropagation();
                if(Utils.isModalHide()) {
                  this.handleBack();
                }
            break;
        }
    }

    @autobind
    private handleKeyPress(e: any): void {
        const { step } = this.state;
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        const back = false;
        const islogin = true;

        if (currentKey === 'BACK') {
            if(step == Steps.STEP_MAIL) {
                e.preventDefault();
                e.stopPropagation();
                HistoryRegion.getUrlLogin(MODAL_REGISTER_NET, this.props, back, islogin )
            } else {
                this.isValidForm = true;
                this.setState({step: Steps.STEP_MAIL, valid:false, errorFromBackend: ''});
            }
        }
    }

    @autobind
    private onFocus (): void  {
        Utils.onFocusElement([{ id: 'emailInput'}, { id: 'password'}]);
    }

    public render(): JSX.Element {
        if (this.state.isLoading) return <Spinner className ={cls(`${LOGIN}-spinner`)} visible={true} />;
        const { step, showPassword, valid, errorFromBackend, focusWhenMount, email } = this.state;
        return (
            <Grid>
                <Row className={cls(`${LOGIN}-row`)}>
                    <Column lg={3} className={cls(`${LOGIN}-header-logo`)}>
                        <img src={this.headerLogo} alt="claroTv logo" />
                    </Column>
                    <Column offset={7} lg={2} className={cls(`${LOGIN}-header-buttons`)}>
                    <ColoredButton
                      onClick={this.handleBack}
                      children = {Translator.get('top_head_option_button_back','REGRESAR')}
                      color="yellow"
                      imgSrc = {Assets.get('top_head_option_back', '')}
                      onFocus = {this.onFocus}
                    />
                    </Column>
                </Row>
                <Row>
                    <Form id="user-registration-form">
                        <Column lg={6} className={cls(`${LOGIN}-column-keyboard`)}>
                            <Keyboard  onFocus = {this.onFocus}/>
                        </Column>
                        <Column lg={6} className={cls(`${LOGIN}-column-inputs`)}>
                            <Row className={cls(`${LOGIN}-row-inputs`)}>
                                {/* ************** TITLE ****************** */}
                                {this.region.toLocaleLowerCase() === 'brasil'  && ( <Column lg={12} className={cls(`${LOGIN}-column-Brasil`)}>
                                    <HeaderLoginLabels typeLogin = {this.typeRegisterNetUpdate} step = {step}></HeaderLoginLabels>
                                </Column>
                                )}

                                {this.region.toLocaleLowerCase() !== 'brasil' &&( <Column lg={12}>
                                    <Heading size={1} className={cls(`${LOGIN}-title`)}>
                                        {this.getTextBySteps('title')}
                                    </Heading>
                                </Column>
                                )}

                                {/* ************** SUBTITLE ****************** */}
                                {this.region.toLocaleLowerCase() !== 'brasil' &&( <Column lg={12}>
                                    <Heading size={2} className={cls(`${LOGIN}-subtitle`)}>
                                        {this.getTextBySteps('subtitle')}
                                    </Heading>
                                </Column>
                                )}

                                {/* ************** INPUT AND  BUTON PASSWORD, EMAIL ****************** */}
                                <Column lg={12} className={cls(`${LOGIN}-column-input`)}>
                                    {step === Steps.STEP_MAIL && (
                                        <FormInput
                                            id = "emailInput"
                                            focusWhenMount = {focusWhenMount}
                                            name="email"
                                            type="alphanumeric"
                                            onChange={this.handleEmailChange}
                                            placeholder={this.getTextBySteps('placeholder')}
                                            errorFromBackend={errorFromBackend}
                                            validInput={valid}
                                            showTooltipSuccess={false}
                                            value={email}
                                        />
                                    )}
                                    {step === Steps.STEP_PASSWORD && (
                                        <Row>
                                            <Column lg={8}>
                                                <FormInput
                                                    id="password"
                                                    focusWhenMount = {focusWhenMount}
                                                    type={
                                                        !showPassword
                                                            ? 'password'
                                                            : 'password_shown'
                                                    }
                                                    onChange={this.handlePasswordChange}
                                                    name="password"
                                                    placeholder={this.getTextBySteps('placeholder')}
                                                    errorFromBackend={errorFromBackend}
                                                    validInput={valid}
                                                />
                                            </Column>
                                            <Column
                                                lg={4}
                                                className={cls(`${LOGIN}-column-show-password`)}
                                            >
                                                <Button
                                                    type="button"
                                                    variant="default"
                                                    className={cls(
                                                        `focusable`,
                                                        `${LOGIN}-button-show-password`
                                                    )}
                                                    onClick={this.changePasswordToShow}
                                                    block
                                                    img = {!showPassword ? this.passwordShowButtonOff : this.passwordShowButtonOn }
                                                >
                                                </Button>
                                            </Column>
                                        </Row>
                                    )}
                                </Column>

                                {/* ************** CANCEL BUTTON AND CONFIRM BUTTON ****************** */}
                                <Column lg={11}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        className={cls(`focusable`, `${LOGIN}-button-next`, this.isValidForm ? '' : 'disabled')}
                                        onClick={this.handleNextStep}
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getTextBySteps('next')}
                                    </Button>
                                </Column>
                                <Column lg={11} className={cls(`${LOGIN}-column-next`)}>
                                    <Button
                                        activate
                                        type="button"
                                        className={cls(`focusable`, `${LOGIN}-button-cancel`)}
                                        onClick={this.handleCancel}
                                        block
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getTextBySteps('cancel')}
                                    </Button>
                                </Column>
                             {/* ************** REGISTER BUTTON ************** */}
                             {step === Steps.STEP_MAIL && (
                                    <Column lg={12}>
                                        <Row className={cls(`${LOGIN}-row-register`)}>
                                            <Column
                                                lg={6}
                                                className={cls(`${LOGIN}-column-button-register`)}
                                            >
                                                <Button
                                                    type="button"
                                                    variant="dark"
                                                    className={cls(
                                                        `focusable`,
                                                        `${LOGIN}-column-button-register`
                                                    )}
                                                    onClick={this.gotoRegister}
                                                    onFocus = {this.onFocus}
                                                >
                                                    <span>
                                                        {this.getTextBySteps('register')}
                                                    </span>
                                                </Button>
                                            </Column>
                                        </Row>
                                    </Column>
                                )}
                                {/* ************** FORGOT PASSWORD ****************** */}
                                {step === Steps.STEP_PASSWORD && (
                                    <Column lg={12}>
                                        <Row className={cls(`${LOGIN}-row-forgotten-password`)}>
                                            <Column
                                                lg={6}
                                                className={cls(
                                                    `${LOGIN}-column-button-forgotten-password`
                                                )}
                                            >
                                                <Button
                                                    type="button"
                                                    variant="dark"
                                                    className={cls(
                                                        `focusable`,
                                                        `${LOGIN}-column-button-forgotten-password`
                                                    )}
                                                    onClick={this.handleForgetPassword}
                                                    onFocus = {this.onFocus}
                                                >
                                                    <span>
                                                        {this.getTextBySteps('forgetPasswordBtn')}
                                                    </span>
                                                </Button>
                                            </Column>
                                        </Row>
                                    </Column>
                                )}
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
    receiveIsLoggedIn,
    setMetricsEvent,
    fetchLinealChannels,
    fetchPushSession,
};

// eslint-disable-next-line no-unused-expressions
// eslint-disable-next-line @typescript-eslint/no-explicit-any


function mapStateToProps(state: any) {
    return {
        user: state.user ? { ...state.user } : {},
    }
}
// const mapStateToProps = (state: { login: {} }): any => {
//     return state.login;
// };
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/authentication/Login/index.tsx